var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DocumentControls',[[_c('apollo-mutation',{attrs:{"mutation":_vm.CREATE_ORDER,"update":_vm.orderCreated},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var mutate = ref.mutate;
var loading = ref.loading;
return [_c('s-button',{attrs:{"disabled":loading || !_vm.validForm,"icon":"save","color":"primary"},on:{"click":function($event){return _vm.save(mutate)}}},[_vm._v(" "+_vm._s(_vm.$t('save'))+" ")])]}}])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }